import { Alert, Box, Container, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';

import { BlogCard } from './BlogCard';
import Grid from '@mui/material/Grid2';
import { MainBlog } from './MainBlog';
import { getBlogs } from '../../services/blogsApi';
import { logger } from '../../utils/logger';
import { useNavigate } from 'react-router-dom';

export const BlogsPage = (props) => {
	const navigate = useNavigate();
	const [listOfBlogs, setListOfBlogs] = useState([]);
	const [alert, setAlert] = useState(false);
	const handleClick = (id) => {
		logger.log('Clicked');
		navigate(`/blogs/${id}`); // Replace '/other-component' with the desired path
	};
	// let listOfBlogs = [
	// 	{
	// 		id: 1,
	// 		title: "",
	// 		description:
	// 			"Lorem ipsum dolor sit amet consectetur. Quis tristique purus amet ipsum nibh. Ornare pellentesque proin enim eu elementum dui dignissim nulla eu. Placerat sed enim et nunc. Vitae feugiat adipiscing congue non habitasse",
	// 		image: BlogCardImg,
	// 	},
	// 	{
	// 		id: 2,
	// 		title: "",
	// 		description:
	// 			"Lorem ipsum dolor sit amet consectetur. Quis tristique purus amet ipsum nibh. Ornare pellentesque proin enim eu elementum dui dignissim nulla eu. Placerat sed enim et nunc. Vitae feugiat adipiscing congue non habitasse",
	// 		image: BlogCardImg,
	// 	},
	// 	{
	// 		id: 3,
	// 		title: "",
	// 		description:
	// 			"Lorem ipsum dolor sit amet consectetur. Quis tristique purus amet ipsum nibh. Ornare pellentesque proin enim eu elementum dui dignissim nulla eu. Placerat sed enim et nunc. Vitae feugiat adipiscing congue non habitasse",
	// 		image: BlogCardImg,
	// 	},
	// 	{
	// 		id: 4,
	// 		title: "",
	// 		description:
	// 			"Lorem ipsum dolor sit amet consectetur. Quis tristique purus amet ipsum nibh. Ornare pellentesque proin enim eu elementum dui dignissim nulla eu. Placerat sed enim et nunc. Vitae feugiat adipiscing congue non habitasse",
	// 		image: BlogCardImg,
	// 	},
	// 	{
	// 		id: 5,
	// 		title: "",
	// 		description:
	// 			"Lorem ipsum dolor sit amet consectetur. Quis tristique purus amet ipsum nibh. Ornare pellentesque proin enim eu elementum dui dignissim nulla eu. Placerat sed enim et nunc. Vitae feugiat adipiscing congue non habitasse",
	// 		image: BlogCardImg,
	// 	},
	// 	{
	// 		id: 6,
	// 		title: "",
	// 		description:
	// 			"Lorem ipsum dolor sit amet consectetur. Quis tristique purus amet ipsum nibh. Ornare pellentesque proin enim eu elementum dui dignissim nulla eu. Placerat sed enim et nunc. Vitae feugiat adipiscing congue non habitasse",
	// 		image: BlogCardImg,
	// 	},
	// ];
	useEffect(() => {
		const fetchBlogs = async () => {
			const response = await getBlogs();
			if (response?.error) {
				setAlert(true);
				const timeoutId = setTimeout(() => {
					setAlert(false);
				}, 5000);

				// Clear timeout if the component re-renders before timeout completes
				return () => clearTimeout(timeoutId);
			} else {
				setListOfBlogs(response?.data);
			}
		};

		fetchBlogs();
	}, []);

	return (
		<>
			{alert && (
				<Alert
					severity="error"
					onClose={() => {
						setAlert(false);
					}}
				>
					Blogs could not be fetched.
				</Alert>
			)}
			<Container maxWidth="xl" sx={{ margin: '0 auto' }}>
				<Box
					sx={{
						px: 4,
						py: 2,
						display: 'flex',
						flexDirection: { xs: 'column', md: 'row' },
						gap: { sm: '1rem,', md: '2rem' },
					}}
				>
					<Box
						onClick={() => handleClick(listOfBlogs?.main?.Blog_ID)}
						style={{ cursor: 'pointer', width: '100%', height: 'auto' }}
					>
						<MainBlog
							title={listOfBlogs?.main?.Blog_Title}
							description={listOfBlogs?.main?.description}
							date={listOfBlogs?.main?.createdOn}
							image={listOfBlogs?.main?.image}
							onClick={() => handleClick(listOfBlogs?.main?.Blog_ID)}
						/>
					</Box>
					<Box>
						<Box
							sx={{ paddingBottom: { sm: '1rem', md: '2rem' } }}
							onClick={() => handleClick(listOfBlogs?.featured?.[0]?.Blog_ID)}
						>
							<BlogCard
								type="Top"
								title={listOfBlogs?.featured?.[0]?.Blog_Title}
								description={listOfBlogs?.featured?.[0]?.description}
								image={listOfBlogs?.featured?.[0]?.image}
							/>
						</Box>
						<Box onClick={() => handleClick(listOfBlogs?.featured?.[1]?.Blog_ID)}>
							<BlogCard
								type="Top"
								title={listOfBlogs?.featured?.[1]?.Blog_Title}
								description={listOfBlogs?.featured?.[1]?.description}
								image={listOfBlogs?.featured?.[1]?.image}
							/>
						</Box>
					</Box>
				</Box>
				<Box sx={{ px: 4, py: 2, alignItems: 'center' }}>
					<Grid container spacing={3} sx={{ justifyContent: 'center' }}>
						{listOfBlogs?.length !== 0 && (
							<Grid size={12}>
								<Typography
									variant="h4"
									sx={{ paddingBottom: '1rem', paddingLeft: '4rem' }}
								>
									MoreBlogs
								</Typography>
							</Grid>
						)}
						{listOfBlogs?.others?.map((item) => (
							<Grid
								item
								xs={12}
								sm={6}
								md={4}
								key={item.id}
								display="flex"
								justifyContent="center"
								alignItems="center"
							>
								<Box
									onClick={() => handleClick(item.Blog_ID)}
									style={{ cursor: 'pointer' }}
								>
									<BlogCard
										type="Bottom"
										title={item?.Blog_Title}
										description={item?.description}
										image={item?.image}
									/>
								</Box>
							</Grid>
						))}
					</Grid>
				</Box>
			</Container>
		</>
	);
};
